const OrganizerId = 1;
const Domain = "https://corre123server.azurewebsites.net/";
const Frontend_Server = "https://corre123frontendserver.azurewebsites.net/"
const Debug_Domain = "http://127.0.0.1:5000/";

export {Domain, OrganizerId, Debug_Domain, Frontend_Server}
